import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { LayoutService } from 'src/app/core/services/layout.service';
import { OnboardingType } from '../../enums/intent.enum';

@Component({
  selector: 'app-onboarding-welcome',
  templateUrl: './onboarding-welcome.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./onboarding-welcome.component.scss'],
})
export class OnboardingWelcomeComponent implements AfterViewInit, OnDestroy {
  @Input()
  onboardingType: OnboardingType;

  private headerHeight = 56;

  constructor(
    private renderer: Renderer2,
    private layoutService: LayoutService
  ) {}

  @HostListener('window:resize', ['$event'])
  handleResize() {
    const newHeight = window.screen.width < 768 ? 0 : 56;

    if (newHeight !== this.headerHeight) {
      setTimeout(() => {
        this.layoutService.headerHeightChange$.next(this.headerHeight);
      });

      this.headerHeight = newHeight;
    }
  }

  ngAfterViewInit() {
    this.handleResize();
    // Add class to change location switcher color
    this.renderer.addClass(document.body, 'white-location-selector');
  }

  ngOnDestroy() {
    if (window.screen.width < 768) {
      const height = this.layoutService.getHeaderHeight();
      this.layoutService.headerHeightChange$.next(height);
    }

    this.renderer.removeClass(document.body, 'white-location-selector');
  }
}
